/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

const MBReconStatusCard: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="bg-white border-2 border-[#FF7043] rounded-2xl shadow-lg p-6">
			<div className="flex items-center gap-2 mb-4 text-[#FF7043]">
				<span className="material-symbols-outlined text-sm font-black">
					info
				</span>
				<span className="text-[10px] font-black uppercase tracking-widest">
					{t(
						"mediaReconcile.mediaBatch.reconciliationStatus",
					)}
				</span>
			</div>
			<p className="text-xs font-bold text-slate-700 leading-relaxed mb-4">
				Batch variance of{" "}
				<span className="text-[#FF7043]">3.6%</span> is
				within the permissible SOP threshold of{" "}
				<span className="text-slate-900 font-black">
					±5%
				</span>
				.
			</p>
			<div className="flex items-center gap-2 text-emerald-600">
				<span className="material-symbols-outlined text-sm font-black">
					check_circle
				</span>
				<span className="text-[10px] font-black uppercase tracking-widest">
					{t(
						"mediaReconcile.mediaBatch.readyForFinalQualityReview",
					)}
				</span>
			</div>
		</div>
	);
};

export default MBReconStatusCard;
